import { render } from "./ReviewMetaLabel.vue?vue&type=template&id=6708a8e2"
import script from "./ReviewMetaLabel.vue?vue&type=script&lang=js"
export * from "./ReviewMetaLabel.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__